import styled from 'styled-components';

/**
 * Notes on implementation: https://iterable.quip.com/Aa5KA29G6sgD/Basic-Table-React-Architecture
 */

const StyledWrapper = styled.div`
  border: 1px solid #d6d6d6;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  margin-bottom: 40px;
  overflow-y: visible;
  min-width: min-content;
`;

const StyledTable = styled.div`
  border-collapse: collapse;
  display: table;
  width: 100%;
`;

// type Props = {
//   children: React.Node,
// };

export const BasicTableWrapper = ({ children, ...props }) => (
  <StyledWrapper data-test="basic-table-container" {...props}>
    {children}
  </StyledWrapper>
);

export const BasicTable = ({ children, ...props }) => (
  <StyledTable data-test="basic-table" role="table" {...props}>
    {children}
  </StyledTable>
);
